export default {
	lang: 'zh',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav": 'VORMOR AI',
		"nav2": '账号安全',
		"nav3": '我的云盘',
		"nav4": '退出登录',
		"nav5": '登录',
		"nav6": '云空间',
		"nav7": 'ChatGPT大模型',
		"nav8": '智能录音笔云空间系统',
		"nav_phone_number_code":'手机号码',
		"nav_update":'更换',
		"nav_bind":'绑定',
		"nav_phone_code_tips":'为确认是您本人操作，请通过手机验证码完成身份验证',
		"nav_phone_number":'手机号',
		"nav_phone_number_verify":'切换手机号验证',
		"nav_phone_email_verify":'切换邮箱验证',
		"nav_set_phone_number":'设置新手机号',
		"nav_verify_login":'验证登录',
		"nav_phone_email":'邮箱/手机号',
		"nav_phone_login":'手机验证登录',
		"nav_email_login":'邮箱验证登录',
		"nav_email_fail":'邮箱格式错误，请重新输入',
		"nav_pw_fail":'密码格式错误，请重新输入',
		"nav_code_fail":'验证码错误',
		"nav_phone_fail":'手机号格式错误，请重新输入',
		"nav_input_fail":'请输入邮箱',
		"nav_input_phone":'请输入手机号',
		"nav_phone_verify_back":'手机验证找回',
		"nav_email_verify_back":'邮箱验证找回'
	},
	login: {
		"login1": '密码登录',
		"login2": '短信登录',
		"loginTab3": '邮箱登录',
		"login3": '邮箱',
		"login4": '登录密码',
		"login5": '手机号',
		"login6": '请选择',
		"login7": '手机验证码',
		"login8": '登录',
		"login9": '忘记密码',
		"login10": '注册',
		"login11": '登录即表示您同意',
		"login12": '服务协议',
		"login13": '隐私协议',
		"login14": '获取',
		"login15": '中国',
		"login16": '请输入账号',
		"login17": '请输入密码',
		"login18": '登录成功!',
		"login19": '请输入验证码!',
		"login20": '发送成功!',
		"login21": '和',
		"login22": '录音笔云盘',
		"login23": '我的写作',
		"login24": '我的对话',
		"login25": '账号安全',
		"login26": '退出登录',
		"login27": '邮箱找回密码',
		"login28": '邮箱',
		"login29": '邮箱验证码',
		"login30": '设置登录密码（6-16位字符）',
		"login31": '再次输入登录密码',
		"login32": '提交',
		"login33": '返回登录',
		"login34": '修改成功!',
	},
	register: {
		"register1": '手机号',
		"register2": '请输入您的手机',
		"register3": '请选择',
		"register4": '手机验证码',
		"register5": '设置密码',
		"register6": '请输入验证码',
		"register7": '6-16位字符',
		"register8": '密码确认',
		"register9": '邮箱',
		"register10": '请输入邮箱',
		"register11": '邮箱验证码',
		"register12": '请输入验证码',
		"register13": '我已阅读并同意',
		"register14": '请阅读并勾选同意协议',
		"register15": '手机号格式错误 / 手机号已注册',
		"register16": '手机验证码错误',
		"register17": '请输入邮箱 / 邮箱格式错误',
		"register18": '邮箱格式错误',
		"register19": '邮箱验证码错误',
		"register20": '密码请设置6-16位字符',
		"register21": '密码格式错误',
		"register22": '两次输入的密码不一致，请重新输入',
		"register23": '请输入密码',
		"register24": '注册成功!',
		"register25": '验证码错误',
	},
	recorder:{
		"recorder1":'录音笔云盘',
		"recorder2":'云空间容量',
		"recorder3":'文件',
		"recorder331":'回收站',
		"recorder332":'全部删除',
		"recorder4":'名称',
		"recorder5":'音频时长',
		"recorder6":'文件大小',
		"recorder7":'创建时间',
		"recorder8":'操作',
		"recorder9":'云空间说明',
		"recorder10":'文件',
		"recorder11":'OCR文件',
		"recorder12":'1. 云空间用途',
		"recorder13":'在智能办公本、录音笔上保存录音、手写笔记后，您可以上传云盘，即使智能设备不在身边，您也可以进入云空间查看笔记文件。',
		"recorder14":'2.如何上传云空间?',
		"recorder15":'录音笔：进入设备【我的文件】→ 点击批量操作 → 点击 “上传”，即可将文件加入云上传队列，上传至云空间。',
		"recorder16":'智能办公本：',
		"recorder17":'方式一：在笔记列表长按，批量选中需要上传的笔记 → 点击 “同步” 完成上传；',
		"recorder171":'方式二：打开单篇笔记详情页 → 点击【更多 - 同步】，即可将该笔记上传至云空间。',
		"recorder18":'未转写',
		"recorder19":'查看摘要',
		"recorder20":'讲话人',
		"recorder21":'编辑讲话人名称',
		"recorder22":'确定',
		"recorder23":'下载',
		"recorder24":'下载内容：',
		"recorder25":'下载设置：',
		"recorder26":'显示说话人',
		"recorder27":'取消',
		"recorder28":'链接分享',
		"recorder29":'获得链接的人都可以访问，仅支持阅读，链接7天有效',
		"recorder30":'复制链接',
		"recorder31":'扫一扫，快速查看',
		"recorder32":'智能整理',
		"recorder33":'区别说话人',
		"recorder34":'按照讲话人角色，智能区分转写文本',
		"recorder35":'智能口语规整',
		"recorder36":'自动过滤语气词、重复词、停顿词',
		"recorder37":'非人声过滤',
		"recorder38":'播放时自动跳过无人声，噪声的音频',
		"recorder39":'请选择',
		"recorder40":'文档',
		"recorder41":'音频',
		"recorder42":'文档+音频',
		"recorder43":'提示',
		"recorder44":'此操作将删除该文件, 是否继续?',
		"recorder441":'此操作将删除全部文件, 是否继续?',
		"recorder45":'确定',
		"recorder46":'取消',
		"recorder47":'删除成功!',
		"recorder48":'已取消删除',
		"recorder49":'暂无标记',
		"recorder50":"正在保存…",
		"recorder51":'回收站',
	},
	personal: {
		"personal1": '账户设置',
		"personal2": '个人信息',
		"personal3": '头像',
		"personal4": '上传文件',
		"personal5": '支持JPG、JPEG、GIF、PNG 风格，支持 2M 以内的图片',
		"personal6": '昵称',
		"personal7": '请输入昵称',
		"personal8": '性别',
		"personal9": '先生',
		"personal10": '女士',
		"personal11": '保密',
		"personal12": '生日',
		"personal13": '请选择生日',
		"personal14": '职业',
		"personal15": '请选择职业',
		"personal16": '请输入职业（非必填）',
		"personal17": '国家',
		"personal18": '请选择国家',
		"personal19": '保存',
		"personal20": '个人信息',
		"personal21": '账户安全',
		"personal22": '只支持2M以内的图片',
		"personal23": '上传成功!',
		"personal24": '修改成功!',
		"personal25": '账户安全',
		"personal26": '登录密码',
		"personal27": '修改',
		"personal28": '电子邮箱',
		"personal29": '更换',
		"personal30": '账号注销',
		"personal32": '确定注销账户吗？',
		"personal33": '注销后，您在帐户下的全部内容将全部清除，请谨慎操作。',
		"personal34": '取消',
		"personal35": '确定',
		"personal36": '身份验证',
		"personal37": '为确认是您本人操作，请通过邮箱验证码完成身份验证',
		"personal38": '邮箱',
		"personal39": '验证码',
		"personal40": '请输入验证码',
		"personal41": '下一步',
		"personal42": '设置新邮箱',
		"personal43": '邮箱',
		"personal44": '请输入新邮箱',
		"personal45": '验证码',
		"personal46": '请输入验证码',
		"personal47": '确定',
		"personal48": '设置新登录密码',
		"personal49": '新登录密码',
		"personal50": '请输入新密码',
		"personal51": '确认新密码',
		"personal52": '请再次输入新密码',
		"personal53": '确定',
		"personal54": '获取',
		"personal55": '邮箱格式错误',
		"personal56": '更换成功!',
		"personal57": '密码请设置6-16位字符',
		"personal58": '两次输入的密码不一致',
		"personal59": '修改成功!',
		"personal60": '注销成功!',
		"share_url": "链接分享",
		"share_url_7_day": "分享链接有效期为7天。失效前，任何获得链接的人都可以访问。",
		"share_audio": "录音音频",
		"share_trans_text": "转写内容",
		"share_summny_text": "总结内容",
		"share_map": "思维导图",
		"share_url_pw": "访问加密",
		"share_random_pw": "密码随机生成",
		"share_url_copy": "复制链接",
		"share_url_copy_success": "复制链接成功",
		"share_link_pw": "访问密码",
		"share_copy_success": "已将转写内容复制到剪切板!",
		"share_copy_success2": "已将总结内容复制到剪切板!",
		"share_speaker": "讲话人",
		"share_no_update_speaker": "不能编辑讲话人为空",
		"share_no_trans":"无转写文本",
		"share_no_summny":"无摘要文本",
		"share_no_map":"无导图内容",
		"share_trans_text_1": "转写",
		"share_summny_text_1": "总结",
		"share_map_1": "导图",
		"share_save": "保存成功",
		"share_no_map":"导图图片未生成",
		"share_update_text": "编辑转写文本",
		"share_update_text2": "编辑总结文本",
		"showLoading": "加载中...",
		"handwriting":"手写内容",
		"handwritingText":"手写",
		"share_1":"本页手写内容未识别",
		"share_2":"编辑手写识别",
		"share_3":"手写识别",
		"share_4":"正在导出文件，请勿离开这个页面",
		"folder_text":"文件夹",
		"folder_text_update_name":"重命名",
		"folder_text_del":"删除",
		"folder_text_all":"全部",
		"folder_text_type":"文件类型",
		"folder_text_audio":"语音笔记",
		"folder_text_writing":"手写笔记",
		"folder_text_file_type":"文件类型",
		"folder_text_add":"新建文件夹",
		"folder_text_input_name":"请输入名称",
		"folder_text_cancel":"取消",
		"folder_text_summit":"确认",
		"folder_text_name_not_null":"名称不能为空",
		"folder_text_add_success":"创建成功!",
		"folder_text_del_confirm":"删除确认",
		"folder_text_confirm":"确定要删除选中的文件夹吗？删除后文件夹下的笔记将移入回收站。",
		"folder_text_del_success":"删除成功!",
		"folder_text_move":"移动到",
		"folder_text_move_success":"移动成功!",
		"folder_update_name":"重命名文件夹",
		"folder_text_update_success":"修改成功!",
		"empty_text":"暂无数据",
		"trans_text_null":"转写文本不能为空",
		"summary_text_null":"摘要总结不能为空",
		"please_create_folder":"请先创建文件夹"
	}
}